export { RecoveryPage as default } from '../../components-v2/auth/AuthPages';
